import React from "react";

import Section from "../../../HOC/Section";

const Service = () => {
  return (
    <Section id="services">
      <div className="container pt-2 pb-5">
        <div className="section-header pt-5 pb-5 text-center">
          <h3 className="section-title">
            <span>Çalışma </span>Alanlarımız
          </h3>
          <h6 className="section-subtitle mr-auto ml-auto"></h6>
        </div>
        <div className="section-content">
          <div className="row">
            <div className="col-md-6 col-lg-4 mb-3">
              <div className="service-box d-flex">
                <div className="service-icon mr-4">
                  <i className="fas fa-user" />
                </div>
                <div className="service-body">
                  <h5 className="service-title">Bireysel Terapi</h5>
                  <p className="service-description">Detaylarını aşağıda belirttiğimiz birçok konuda siz değerli danışanlarımıza destek sağlıyoruz.

                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 mb-3">
              <div className="service-box d-flex">
                <div className="service-icon mr-4">
                  <i className="fas fa-users" />
                </div>
                <div className="service-body">
                  <h5 className="service-title">Aile ve Çift Terapisi</h5>
                  <p className="service-description">
                  Detaylarını aşağıda belirttiğimiz birçok konuda siz değerli danışanlarımıza destek sağlıyoruz.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 mb-3">
              <div className="service-box d-flex">
                <div className="service-icon mr-4">
                  <i className="fas fa-puzzle-piece" />
                </div>
                <div className="service-body">
                  <h5 className="service-title">Oyun Terapisi</h5>
                  <p className="service-description">
                  Detaylarını aşağıda belirttiğimiz birçok konuda siz değerli danışanlarımıza destek sağlıyoruz.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 mb-3">
              <div className="service-box d-flex">
                <div className="service-icon mr-4">
                  <i className="fas fa-user-clock" />
                </div>
                <div className="service-body">
                  <h5 className="service-title">Ergen Terapisi</h5>
                  <p className="service-description">
                  Detaylarını aşağıda belirttiğimiz birçok konuda siz değerli danışanlarımıza destek sağlıyoruz.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 mb-3">
              <div className="service-box d-flex">
                <div className="service-icon mr-4">
                  <i className="far fa-building" />
                </div>
                <div className="service-body">
                  <h5 className="service-title">Kurumsal Danışmanlık</h5>
                  <p className="service-description">
                  Detaylarını aşağıda belirttiğimiz birçok konuda siz değerli danışanlarımıza destek sağlıyoruz.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 mb-3">
              <div className="service-box d-flex">
                <div className="service-icon mr-4">
                  <i className="fas fa-globe" />
                </div>
                <div className="service-body">
                  <h5 className="service-title">Online Terapi</h5>
                  <p className="service-description">
                  Detaylarını aşağıda belirttiğimiz birçok konuda siz değerli danışanlarımıza destek sağlıyoruz.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 mb-3">
              <div className="service-box d-flex">
                <div className="service-icon mr-4">
                  <i class="fas fa-home"></i>
                </div>
                <div className="service-body">
                  <h5 className="service-title">Ebeveyn Danışmanlığı</h5>
                  <p className="service-description">
                  Detaylarını aşağıda belirttiğimiz birçok konuda siz değerli danışanlarımıza destek sağlıyoruz.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 mb-3">
              <div className="service-box d-flex">
                <div className="service-icon mr-4">
                  <i className="fas fa-gamepad" />
                </div>
                <div className="service-body">
                  <h5 className="service-title">Psikolojik Test</h5>
                  <p className="service-description">
                  Detaylarını aşağıda belirttiğimiz birçok konuda siz değerli danışanlarımıza destek sağlıyoruz.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 mb-3">
              <div className="service-box d-flex">
                <div className="service-icon mr-4">
                  <i className="fas fa-child" />
                </div>
                <div className="service-body">
                  <h5 className="service-title">Çocuk Terapisi</h5>
                  <p className="service-description">
                  Detaylarını aşağıda belirttiğimiz birçok konuda siz değerli danışanlarımıza destek sağlıyoruz.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="section-content">
            <div className="row">
              <div className="col-md-12 col-lg-12 mb-12">
                <ul class="list-group">
                  <li class="list-group-item active" aria-current="true">
                    <b>Bireysel Terapi</b>
                  </li>
                  <li class="list-group-item">·        Depresyon</li>
                  <li class="list-group-item">
                    ·        Duygudurum Bozuklukları
                  </li>
                  <li class="list-group-item">·        Panik Atak</li>
                  <li class="list-group-item">
                    ·        Travma Sonrası Stres Bozukluğu
                  </li>
                  <li class="list-group-item">
                    ·        Obsesif Kompülsif Bozukluk
                  </li>
                  <li class="list-group-item">
                    ·        Yaygın Anksiyete Bozukluğu
                  </li>
                  <li class="list-group-item">·        Sosyal Anksiyete</li>
                  <li class="list-group-item">
                    ·        Somatizasyon Bozukluğu
                  </li>
                  <li class="list-group-item">
                    ·        Alkol ve Madde Kullanım Bozukluğu
                  </li>
                  <li class="list-group-item">·        Kumar Bağımlılığı</li>
                  <li class="list-group-item">·        Özgül Fobiler</li>
                  <li class="list-group-item">·        Sosyal Fobi</li>
                  <li class="list-group-item">
                    ·        Yaşamsal Olaylara Uyum
                  </li>
                  <li class="list-group-item">
                    ·        Aile İçi İletişim Sorunları
                  </li>
                  <li class="list-group-item">
                    ·        Öfke Kontrol Sorunları
                  </li>
                  <li class="list-group-item">
                    ·        İlişkisel Zorluklar(Yalnızlık, Uyum Sorunları,
                    Kıskançlık, Boşanma, Yeniden Evlenme Süreçleri
                  </li>
                  <li class="list-group-item">
                    ·        İş Hayatına Yönelik Problemler
                  </li>
                </ul>
                <br/>
                <ul class="list-group">
                  <li class="list-group-item active" aria-current="true">
                    <b>Çocuk Terapisi</b>
                  </li>
                  <li class="list-group-item">
                    ·        Gelişimsel Problemler
                  </li>
                  <li class="list-group-item">·        Bağlanma Sorunları</li>
                  <li class="list-group-item">·        Davranış Problemleri</li>
                  <li class="list-group-item">·        Tuvalet Eğitimi</li>
                  <li class="list-group-item">
                    ·        Alt Islatma(Enürezis)
                  </li>
                  <li class="list-group-item">
                    ·        Kaka Tutma(Enkoprezi)
                  </li>
                  <li class="list-group-item">·        Tırnak Yeme</li>
                  <li class="list-group-item">·        Yalan Söyleme</li>
                  <li class="list-group-item">·        Saldırganlık</li>
                  <li class="list-group-item">
                    ·        Beslenme ve Yeme Problemleri
                  </li>
                  <li class="list-group-item">·        Korkular- Kaygılar</li>
                  <li class="list-group-item">·        Çocukluk Depresyonu</li>
                  <li class="list-group-item">·        Kardeş Kıskançlığı</li>
                  <li class="list-group-item">·        Öğrenme Güçlüğü</li>
                  <li class="list-group-item">
                    ·        Dikkat Eksikliği ve Hiperaktive Bozukluğu
                  </li>
                  <li class="list-group-item">
                    ·        Çocukluk Mastürbasyonu
                  </li>
                  <li class="list-group-item">·        Tikler</li>
                  <li class="list-group-item">·        Özgül Fobiler</li>
                  <li class="list-group-item">
                    ·        Ağlama ve Öfke Nöbetleri
                  </li>
                </ul>
                
                <br/>
                <ul class="list-group">
                  <li class="list-group-item active" aria-current="true">
                    <b>Ergen Terapisi</b>
                  </li>
                  <li class="list-group-item">
                    ·        Ergenlik Döneminin Gelişimsel Özellikleri
                  </li>
                  <li class="list-group-item">
                    ·        Kimlik Karmaşası ve Kişilik Gelişimi
                  </li>
                  <li class="list-group-item">
                    ·        Ergen ve Ebeveyn Arasındaki İletişim Problemleri
                  </li>
                  <li class="list-group-item">
                    ·        Aileden Ayrışma ve Bireyselleşme
                  </li>
                  <li class="list-group-item">
                    ·        Arkadaş İlişkileri ve Duygusal Sorunlar
                  </li>
                  <li class="list-group-item">·        Özgüven Problemleri</li>
                  <li class="list-group-item">
                    ·        Meslek ve Kariyer Danışmanlığı
                  </li>
                  <li class="list-group-item">·        Sınav Kaygısı</li>
                  <li class="list-group-item">·        Gelecek Kaygısı</li>
                  <li class="list-group-item">
                    ·        Cinsel Gelişim ile İlgili Danışmanlık
                  </li>
                  <li class="list-group-item">
                    ·        Teknoloji Bağımlılığı
                  </li>
                </ul>
                <br/>
                <ul class="list-group">
                  <li class="list-group-item active" aria-current="true">
                    <b>Aile ve Çift Terapisi</b>
                  </li>
                  <li class="list-group-item">
                    ·        Aile İçi İletişim Sorunları
                  </li>
                  <li class="list-group-item">·        Çatışmalar</li>
                  <li class="list-group-item">
                    ·        Boşanma ve Boşanma Sonrası Süreç
                  </li>
                  <li class="list-group-item">·        Aldatma</li>
                  <li class="list-group-item">
                    ·        İlişki İçindeki Temel İhtiyaçlar
                  </li>
                </ul>
                <br/>
                <ul class="list-group">
                  <li class="list-group-item active" aria-current="true">
                    <b>Cinsel Terapiler</b>
                  </li>
                  <li class="list-group-item">·        Vajinismus</li>
                  <li class="list-group-item">·        Disparoni</li>
                  <li class="list-group-item">·        Cinsel İsteksizlik</li>
                </ul>
                <br/>
                <ul class="list-group">
                  <li class="list-group-item active" aria-current="true">
                    <b>Ebeveyn Danışmanlığı</b>
                  </li>
                  <li class="list-group-item">
                    ·        0-6 Yaş Ruhsal, Bilişsel, Sosyal ve Duygusal
                    Gelişimsel Değerlendirme ve Takip
                  </li>
                  <li class="list-group-item">
                    ·        0-6 Yaş Dönemi Uyku, Beslenme ve Tuvalet
                    Alışkanlığı
                  </li>
                  <li class="list-group-item">
                    ·        Ebeveyn-Çocuk İlişkisi Değerlendirme ve Danışmanlık
                  </li>
                  <li class="list-group-item">
                    ·        Boşanma, Taşınma, Ayrılık, Yas ve Okula Başlama ile
                    İlgili Süreç Yönetimi
                  </li>
                </ul>
                <br/>
                <ul class="list-group">
                  <li class="list-group-item active" aria-current="true">
                    <b>Psikolojik Testler ve Değerlendirme</b>
                  </li>
                  <li class="list-group-item">·        Oyun Terapisi</li>
                  <li class="list-group-item">
                    ·        Wechsler Çocuklar İçin Zeka Ölçeği(WISCH-R)
                  </li>
                  <li class="list-group-item">·        Moxo Dikkat Testi</li>
                  <li class="list-group-item">
                    ·        Attentioner Dikkatimi Topluyorum Programı
                  </li>
                  <li class="list-group-item">
                    ·        Minnesota Çok Yönlü Kişilik Envanteri(MMPI)
                  </li>
                  <li class="list-group-item">
                    ·        Stanford Binet Zeka Testi
                  </li>
                  <li class="list-group-item">
                    ·        Ankara Gelişim Envanter(AGTE)
                  </li>
                  <li class="list-group-item">
                    ·        Bier Cümle Tamamlama Testi
                  </li>
                  <li class="list-group-item">
                    ·        Bender-Gestalt Görsel Motor Algılama Testi
                  </li>
                  <li class="list-group-item">
                    ·        Gessel Gelişim Figürleri Testi
                  </li>
                  <li class="list-group-item">
                    ·        Metropolitan Okul Olgunluğu Testi
                  </li>
                  <li class="list-group-item">
                    ·        Peabody Resim Kelime Testi
                  </li>
                  <li class="list-group-item">·        Arzu Listesi Testi</li>
                  <li class="list-group-item">
                    ·        Frakfurter Dikkat Testi
                  </li>
                  <li class="list-group-item">·        D2 Dikkat Testi</li>
                  <li class="list-group-item">
                    ·        Louisa Duss Psikanalitik Hikayeler Testi
                  </li>
                  <li class="list-group-item">·        Burdon Dikkat Testi</li>
                  <li class="list-group-item">
                    ·        Frosting Gelişimsel Görsel Algı Testi
                  </li>
                  <li class="list-group-item">
                    ·        Catell 2-A Zeka Testi
                  </li>
                  <li class="list-group-item">·        Sınav Kaygısı Ölçeği</li>
                  <li class="list-group-item">·        Bir İnsan Çiz Testi</li>
                  <li class="list-group-item">·        Bir Adam Çiz Testi</li>
                </ul>

                
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default Service;
